import { memo } from 'react';

export const TextWithStyledDigits = memo(({ text, fontSize }) => {
  if (!text) {
    return '';
  }
  const parts = text.split(/(\d+)/);

  return (
    <div>
      {parts.map((part, index) =>
        /\d+/.test(part) ? (
          <span key={index} style={{ fontSize }}>
            {part}
          </span>
        ) : (
          part
        )
      )}
    </div>
  );
});
